export enum AffectedHand {
  LEFT = 'LEFT',
  RIGHT = 'RIGHT'
}

export const affectedHandName = (hand: AffectedHand): string => (hand === AffectedHand.LEFT ? 'Левая' : 'Правая');
